export const enTranslations = {
    page: {
        learning: 'My Learning',
        tournament: 'Tournament',
        tournaments: 'Tournaments',
        settings: 'User Settings',
        termsConditions: 'Terms & Conditions',
        notifications: 'Notifications',
        help: 'Help',
        assignments: 'Assignments',
        performance: 'Performance',
        management: 'Management',
        managementUsers: 'User Profiles',
        managementGroups: 'User Groups',
    },
    menu: {
        buttons: {
            product: 'Product page',
        },
    },
    footer: {
        copyright: '© 2025 RoadMaster VR. All rights reserved.',
    },
    common: {
        loading: 'Loading',
        daysAbbr: 'd',
        hoursAbbr: 'h',
        minutesAbbr: 'min',
        status: {
            notStarted: 'Not Started',
            inProgress: 'In Progress',
            progress: 'In Progress',
            completed: 'Completed',
            passed: 'Passed',
            failed: 'Failed',
            running: 'Running',
            active: 'Active',
            inactive: 'Inactive',
            draft: 'Draft',
            ready: 'Ready',
            offline: 'Offline',
            starting: 'Starting',
            stopped: 'Stopped',
            started: 'Started',
            required: 'Required',
            optional: 'Optional',
        },
    },
    title: {
        courseDetail: 'RoadMaster VR Course Detail',
        learnings: 'RoadMaster VR Learnings',
        settings: 'RoadMaster VR Settings',
        main: 'RoadMaster VR Platform',
        login: 'RoadMaster VR Login',
        reset: 'RoadMaster VR Password Reset',
        changePassword: 'RoadMaster VR Change Password',
        tournament: 'RoadMaster VR Tournament',
        tournaments: 'RoadMaster VR Tournaments',
        error: 'RoadMaster VR Error',
        assignments: 'RoadMaster VR Assignments',
    },
    error: {
        userLearningsTitle: 'User learnings failed',
        userPasswordTitle: 'User password failed',
        userSettingsTitle: 'User settings failed',
        loginTitle: 'Login failed',
        logoutTitle: 'Logout failed',
        baseInfoTitle: 'Base info failed',
        resetTitle: 'Reset failed',
        changePasswordTitle: 'Change Password failed',
        missingTokenTitle: 'Missing reset token',
        missingTokenMessage: 'Reset token is not provided',
        missingUsernameTitle: 'Missing username reference',
        missingUsernameMessage: 'Username reference is not provided',
        missingProgramId: 'Program id is missing',
        missingLessonId: 'Lesson id is missing',
        serverError: 'Server error',
    },
    success: {
        check: 'Valid',
        userSettingsTitle: 'Success',
        userPasswordTitle: 'Success',
    },
    launcherUpdate: {
        title: 'Simulator launcher update needed.',
        message:
            'Restart the RoadMaster launcher (or the computer) on: {{computers}}. It will then install version {{version}} automatically.',
        badge: 'Update needed',
    },
    pagination: {
        goTo: 'Go to page',
        previous: 'Previous',
        next: 'Next',
        submit: 'Submit',
        of: 'of',
        rowsPerPage: 'Rows per page',
    },
    tournamentsPage: {
        title: 'Tournaments',
        emptyState: 'No tournaments created. If you require a tournament, please contact technical support.',
        headers: {
            name: 'Tournament name',
            status: 'Status',
            participants: 'Participants',
            statsAt: 'Starts At',
            endsAt: 'Ends At',
            actions: 'Actions',
        },
    },
    assignmentCrudPage: {
        basicInfo: 'Basic Information',
        titleCreate: 'Create New assignment',
        titleEdit: 'Edit assignment',
        or: 'or',
        selectedUsers: 'Selected Users',
        selectedContent: 'Select content',
        selectedOnly: 'Selected only',
        usersSelected: 'Users selected',
        contentSelected: 'Content selected',
        filters: {
            show: 'Show',
            programs: 'Programs',
            courses: 'Courses',
            tags: 'Tags',
            searchBy: 'Search by',
            selected_only: 'Selected only',
            findProgramsCourses: 'Find Programs & Courses',
            findUsers: 'Search Users or User Groups',
            findProgramsCoursesPlaceholder: 'Search by Name or Tag',
            findUsersPlaceholder: 'Search by Name or User Group',
            Days: 'Day',
            Weeks: 'Week',
            Months: 'Month',
        },
        modal: {
            titleDiscard: 'Are you sure you want to Discard Assignment?',
            textDiscard: 'Reactivation won’t be possible after assignments deactivation.',
            titleDraft: 'Are you sure you want to Save as draft?',
            textDraft: 'New assignment draft will be created.',
            titlePublish: 'Are you sure you want to Save and publish?',
            textPublish: 'Assignment will be visible for users and groups.',
            titleDeactivate: 'Are you sure you want to Deactivate Assignment?',
            textDeactivate: 'If deactivated, will be shown as inactive status',
            titleBack: 'Are you sure you want to go Back to Assignments? ',
            buttons: {
                cancel: 'Cancel',
                discard: 'Discard',
                deactivate: 'Deactivate',
                saveDraft: 'Save as draft',
                savePublish: 'Save and publish',
                back: 'Assignments List',
            },
        },
        buttons: {
            discard: 'Discard',
            save: 'Save and publish',
            saveDraft: 'Save as draft',
            deactivate: 'Deactivate',
            savePublish: 'Save and publish',
            back: 'Back to Assignments',
            edit: 'Edit',
            cancel: 'Cancel',
        },
        labels: {
            name: 'Assignment Name',
            type: 'Assignment Type',
            dueDate: 'Due date',
            duration: 'Duration',
            requiredAssignment: 'Required assignment',
            timeFrame: 'Time frame',
        },
        headers: {
            userName: 'Name',
            email: 'E-mail',
            assignmentName: 'Name',
            tags: 'Tags',
            createdBy: 'Created by',
            createdAt: 'Creation date',
            type: 'Type',
        },
    },
    assignmentsPage: {
        buttons: {
            create: 'Create Assignment',
        },
        filters: {
            assignmentName: 'Search assignments',
            type: 'Type',
            status: 'Status',
            placeholder: 'Search',
            all: 'All',
        },
        headers: {
            assignmentName: 'Assignment name',
            type: 'Type',
            status: 'Status',
            learners: 'Learners',
            createdBy: 'Created by',
            createdAt: 'Creation date',
            duaDate: 'Due date',
            actions: 'Actions',
        },
        tooltips: {
            edit: 'Edit',
            assignmentDetails: 'Assignment Management',
            performance: 'Performance',
        },
        title: 'Assignments',
        subTitle: 'Assignments',
    },
    assignmentManagePage: {
        headers: {
            computer: 'Computer',
            status: 'Status',
            driver: 'Driver',
            lesson: 'Lesson',
            type: 'Type',
            mode: 'Mode',
            actions: 'Actions',
            totalScore: 'Total score',
            attempt: 'Attempt',
            simulator: 'Simulator',
        },
        driverRow: {
            driverName: 'Driver name',
            internalId: 'Internal ID',
            country: 'Country',
            completionRate: 'Completion rate',
            completion: 'Completion',
        },
        buttons: {
            stop: 'Stop',
            view: 'View',
            run: 'Run',
            starting: 'Starting...',
        },
        actions: {
            expandAll: 'Expand All',
            collapseAll: 'Collapse All',
        },
        search: {
            placeholder: 'Search drivers by name, ID or country...',
        },
        simulator: {
            selectSimulator: 'Select simulator',
        },
        status: {
            notStarted: 'Not Started',
            completed: 'Completed',
            inProgress: 'In Progress',
            running: 'Running',
        },
        sort: {
            sortBy: 'Sort by',
            sortDriversBy: 'Sort Drivers By',
            default: 'Default',
            completionDesc: 'Completion % (High to Low)',
            completionAsc: 'Completion % (Low to High)',
            avgScoreDesc: 'Avg Score (High to Low)',
            avgScoreAsc: 'Avg Score (Low to High)',
            statusProgress: 'In Progress First',
            statusNotStarted: 'Not Started First',
            statusCompleted: 'Completed First',
            attemptsDesc: 'Most Attempts First',
            attemptsAsc: 'Least Attempts First',
        },
        modals: {
            notes: {
                title: 'Add Instructor Note',
                subtitle: 'Add a note for',
                placeholder: 'Enter your note here...',
                cancel: 'Cancel',
                save: 'Save Note',
            },
            config: {
                title: 'Advanced Settings',
                simulationType: 'Simulation Type (Device Type)',
                lessonLanguage: 'Lesson Language',
                aiTraffic: 'AI Traffic',
                timeOfDay: 'Time of Day',
                weather: 'Weather',
                vrTutorial: 'VR Tutorial',
                lessonDefault: 'Lesson Default',
                vr: 'VR',
                screen: 'Screen',
                yes: 'Yes',
                no: 'No',
                day: 'Day',
                night: 'Night',
                clear: 'Clear',
                rain: 'Rain',
                storm: 'Storm',
                cancel: 'Cancel',
                save: 'Save',
                languages: {
                    eng: 'ENG',
                    lt: 'LT',
                    ru: 'RU',
                },
            },
            computerStatus: {
                component: 'Component',
                status: 'Status',
                notes: 'Notes',
                lastOnline: 'Last Online',
                refreshing: 'Refreshing',
                refresh: 'Refresh',
                close: 'Close',
            },
            statusChange: {
                title: 'Change lesson status',
                message: 'Change the status of {{driver}} - {{lesson}} to "{{status}}"? This affects completion stats.',
                confirm: 'Change status',
                cancel: 'Cancel',
            },
        },
        errors: {
            createLessonAttemptFailed: 'Failed to start the lesson. Please try again.',
            updateLessonAttemptStatusFailed: 'Failed to update the lesson status. Please try again.',
        },
    },
    performancePage: {
        title: 'Driver Lesson Performance',
        export: 'Export',
        filters: {
            team: 'Team',
            content: 'Content',
            totalScore: 'Total score',
            date: 'Date',
            allDrivers: 'All Drivers',
            byDriver: 'By Driver',
            byGroup: 'By Group',
            search: 'Search',
            noGroupsAvailable: 'No groups available',
            allContent: 'All Content',
            byLesson: 'By Lesson',
            byAssignment: 'By Assignment',
            lessons: 'Lessons',
            assignments: 'Assignments',
            allLessons: 'All Lessons',
            lastAttempt: 'Last attempt',
            onlyExams: 'Only exams',
            clear: 'Clear',
            apply: 'Apply',
            last1Month: 'Last 1 month',
            last2Months: 'Last 2 months',
            last3Months: 'Last 3 months',
            last6Months: 'Last 6 months',
            last12Months: 'Last 12 months',
            timeFrame: 'Time frame',
        },
        kpi: {
            driversEnrolled: 'Drivers enrolled',
            avgTimeSpent: 'Average time spent learning',
            avgScore: 'Average score',
            completionRate: 'Completion rate',
            kpi: 'KPI',
            kpis: 'KPIs',
        },
        table: {
            lesson: 'Lesson',
            type: 'Type',
            mode: 'Mode',
            status: 'Status',
            totalScore: 'Total score',
            startDate: 'Start date/Time',
            sessionDuration: 'Session duration',
            attempt: 'Attempt',
            details: 'Details',
        },
        driverRow: {
            internalId: 'Internal ID',
            country: 'Country',
            completionRate: 'Completion rate',
            completion: 'Completion',
        },
        actions: {
            expandAll: 'Expand All',
            collapseAll: 'Collapse All',
        },
        search: {
            placeholder: 'Search drivers by name, ID or country...',
        },
        status: {
            notStarted: 'Not Started',
            completed: 'Completed',
            inProgress: 'In Progress',
            progress: 'In Progress',
            running: 'Running',
            passed: 'Passed',
            failed: 'Failed',
        },
        sort: {
            sortBy: 'Sort by',
            sortDriversBy: 'Sort Drivers By',
            default: 'Default',
            completionDesc: 'Completion % (High to Low)',
            completionAsc: 'Completion % (Low to High)',
            avgScoreDesc: 'Avg Score (High to Low)',
            avgScoreAsc: 'Avg Score (Low to High)',
            statusProgress: 'In Progress First',
            statusNotStarted: 'Not Started First',
            statusCompleted: 'Completed First',
            attemptsDesc: 'Most Attempts First',
            attemptsAsc: 'Least Attempts First',
        },
        selection: {
            of: 'of',
            drivers: 'drivers',
            selectAll: 'Select All',
        },
        details: {
            driverName: 'Driver name',
            internalId: 'Internal ID',
            country: 'Country',
            completionRate: 'Completion rate',
            startDate: 'Start date',
            startDateTime: 'Start date/Time',
            generalInfo: 'General Information',
        },
        metrics: {
            results: 'Results',
            yourResult: 'Your Result',
            goal: 'Goal',
        },
        emptyState: {
            title: 'No data available',
            message: 'No performance data found for the selected filters. Try adjusting your filters to see results.',
        },
    },
    error404Page: {
        title: 'Page not found!',
        subTitle: 'Error: 404',
        text: 'The requested URL doesn’t exist',
    },
    error500Page: {
        title: 'Internal Server Error',
        subTitle: 'Error: 500',
        text: 'The server encountered an internal error or misconfigurarion and was uanble to complete your request',
    },
    tournamentPage: {
        leaderboard: 'Leaderboard',
        join: 'Join',
        tournament: 'tournament!',
        emptyState: 'No tournaments created. If you require a tournament, please contact technical support.',
        form: {
            playerName: 'Player Name',
            computer: 'Computer',
            start: 'Start',
            stop: 'Stop',
        },
        banner: {
            total: 'TOTAL',
            drivers: 'DRIVERS',
            tournament: 'TOURNAMENT',
            ends: 'ENDS',
            time: 'TIME',
            left: 'LEFT',
            hours: 'Hours',
            minutes: 'Minutes',
            seconds: 'Seconds',
            winners: 'Leaderboard',
        },
        session: {
            totalScore: 'TOTAL SCORE',
            speedingFine: 'SPEEDING FINE',
            time: 'TIME',
            conesHit: 'CONES HIT',
        },
    },
    courseDetailPage: {
        buttons: {
            start: 'Start',
            continue: 'Continue',
            retake: 'Retake',
            next: 'Next',
            submit: 'Submit',
            terminate: 'Terminate lesson',
        },
        popover: {
            launch: 'Launch',
            form: {
                computer: 'Choose simulator',
                start: 'Start',
                stop: 'Cancel',
            },
        },
        keyKpis: {
            title: 'Key Lesson Statistics',
        },
        nonKeyKpis: {
            title: 'Overview',
        },
        kpis: {
            score: 'Your result',
            goal: 'Goal',
        },
        yourResult: 'Your result',
        status: {
            notStarted: 'Not Started',
            progress: 'In Progress',
            passed: 'Passed',
            failed: 'Failed',
            running: 'Running',
        },
        quizResults: {
            thanks: 'Thank you!',
            completed: 'Quiz is completed',
        },
        surveyResults: {
            thanks: 'Thank you!',
            completed: 'Survey is completed',
        },
        type: 'Type',
        yourAnswer: 'Your answer',
        submitInfo: 'Questions left',
        menu: 'LESSON MENU',
        description: 'Lesson description',
        question: 'Question',
        contentDescription: 'To unlock the content please start a lesson',
        content: 'Content',
        collapse: 'Arrow down',
        expand: 'Arrow up',
        assigned: 'ASSIGNED',
        dueby: 'DUE BY',
        completed: 'COMPLETED',
        completedIn: 'COMPLETED IN',
        started: 'STARTED',
        duration: 'DURATION',
        hour: 'h',
        min: 'min',
        sec: 's',
        lesson: 'Lesson',
        drop: 'Drop answer here',
        parkingPosition: 'Parking Position',
    },
    learningsPage: {
        emptyState: 'No lessons assigned',
        meta: {
            finishedTotal: 'Finished / Total programs',
            coursesLessons: 'Courses / Lessons left to complete',
            deadline: 'Closest deadline',
        },
        data: {
            program: {
                title: 'PROGRAM',
                collapse: 'Arrow down',
                expand: 'Arrow up',
                course: 'COURSE',
            },
            course: {
                buttons: {
                    start: 'Start',
                    continue: 'Continue',
                    starting: 'Starting...',
                },
                collapse: 'Arrow down',
                expand: 'Arrow up',
                assigned: 'ASSIGNED',
                dueby: 'DUE BY',
            },
            lesson: {
                lesson: 'Lesson',
                locked: 'Locked',
                completed: 'Completed',
            },
            overview: {
                buttons: {
                    more: 'Read more',
                    less: 'Read less',
                },
                lessonsLeft: 'LESSONS DONE',
                dueby: 'DUE BY',
                assigned: 'ASSIGNED',
                duration: 'DURATION',
            },
        },
        title: 'My Learnings',
    },
    settingsPage: {
        buttons: {
            save: 'Save',
            update: 'Update Password',
            cancel: 'Cancel',
        },
        labels: {
            name: 'Name',
            phoneNumber: 'Phone number',
            jobRole: 'Job role',
            surname: 'Surname',
            company: 'Company',
            cardNumber: 'Tacho card number',
            email: 'E-mail',
            password: 'Password',
            lastUpdated: 'Last time updated',
            changePassword: 'Change password',
            selectLanguage: 'Select language',
        },
        info: 'To change user data please contact your instructor.',
        form: {
            reminders: 'Reminders',
            marketingMessages: 'Marketing messages',
            language: 'Language',
            oldPassword: 'Old password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
            passwordError: 'The passwords you entered don’t match',
        },
        title: 'User settings',
    },
    loginPage: {
        buttons: {
            contact: 'Contact us',
            login: 'Login',
        },
        form: {
            email: 'E-mail',
            emailError: 'Please enter a valid e-mail address',
            password: 'Password',
            forgotPassword: 'Forgot password',
            rememberMe: 'Remember me',
        },
        title: 'Login to Learning Management System',
        subtitle: 'Not a member yet?',
    },
    resetPage: {
        buttons: {
            back: 'Back to login screen',
            reset: 'Get recovery link',
        },
        form: {
            email: 'Enter valid e-mail',
            emailError: 'Please enter a valid e-mail address',
        },
        title: 'Password reset',
    },
    changePasswordPage: {
        buttons: {
            back: 'Back to login screen',
            change: 'Change',
        },
        form: {
            password: 'Enter new password',
            repeatPassword: 'Repeat password',
            passwordError: 'The passwords you entered don’t match',
        },
        title: 'Change password',
    },
    userProfiles: {
        headers: {
            lmsId: 'LMS ID',
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            employeeId: 'Employee ID',
            registrationDate: 'Registration Date',
            status: 'Status',
            actions: 'Actions',
        },
        search: {
            placeholder: 'Search by email, name or employee ID...',
        },
        tooltips: {
            edit: 'Edit',
            deactivate: 'Deactivate',
            activate: 'Activate',
            remove: 'Remove from UI',
        },
        errors: {
            removeFailed: 'Failed to remove user. Please try again.',
            toggleFailed: 'Failed to toggle user status. Please try again.',
            loadFailed: 'Failed to load users. Please try again.',
            updateFailed: 'Failed to update user. Please try again.',
        },
        modals: {
            removeUser: {
                title: 'Remove user from system?',
                message:
                    'This action will remove the user from all visible lists in the LMS. The user will no longer be selectable in new assignments.',
                cancel: 'Cancel',
                confirm: 'Remove',
            },
        },
        createUser: 'Create user',
    },
    editUser: {
        title: 'Update User',
        lmsId: 'LMS ID',
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        employeeId: 'Employee ID',
        company: 'Company',
        registrationDate: 'Registration Date',
        language: 'Language',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        newPassword: 'New Password',
        newPasswordHelper: 'Leave empty to keep current',
        userGroups: 'User Groups',
        groupsDisclaimer:
            'Group membership defines participation in future assignments. Existing assignments are not affected.',
        save: 'Save',
        discard: 'Discard',
        sendReset: 'Send password reset email',
        updateSuccess: 'User updated successfully',
        resetSent: 'Password reset email sent',
        requiredFieldsError: 'Please fill in all required fields.',
        english: 'English',
        lithuanian: 'Lithuanian',
        russian: 'Russian',
    },
    userGroups: {
        headers: {
            groupId: 'Group ID',
            name: 'Name',
            description: 'Description',
            userCount: 'Users',
        },
        emptyState: 'No groups created yet',
        createGroup: 'Create group',
        search: 'Search groups...',
        tooltips: {
            edit: 'Edit group',
            remove: 'Remove group',
            removeDisabled:
                'Group cannot be removed while users are assigned. Please remove all users from the group first.',
        },
        modals: {
            removeGroup: {
                title: 'Delete group?',
                message:
                    'This action will delete the group from active use in the LMS. Users assigned to this group will not be deleted. Historical data related to past assessments, assignments, and performance will remain unchanged.',
                confirm: 'Remove',
                cancel: 'Cancel',
            },
        },
        errors: {
            removeFailed: 'Failed to remove group. Try again.',
        },
        success: {
            removed: 'Group removed successfully',
        },
    },
    createGroup: {
        title: 'Create Group',
        groupName: 'Group Name',
        description: 'Description',
        create: 'Create',
        discard: 'Discard',
        users: {
            title: 'Assign Users',
            searchPlaceholder: 'Search by first name, last name, or employee ID...',
            add: 'Add',
            remove: 'Remove {{name}}',
            addedTitle: 'Assigned Users',
            columns: {
                name: 'Name',
                email: 'Email',
                employeeId: 'Employee ID',
            },
        },
        success: {
            created: 'Group created successfully',
        },
        errors: {
            nameRequired: 'Group name is required.',
            createFailed: 'Failed to create group. Try again.',
        },
    },
    editGroup: {
        title: 'Edit Group',
        general: 'General',
        groupName: 'Group Name',
        description: 'Description',
        users: {
            title: 'Assigned Users',
            searchPlaceholder: 'Search by first name, last name, or employee ID...',
            add: 'Add',
            remove: 'Remove {{name}}',
            addedTitle: 'Assigned Users',
            columns: {
                name: 'Name',
                email: 'Email',
                employeeId: 'Employee ID',
            },
            disclaimer:
                'Group membership defines participation in future assignments. Existing assignments are not affected.',
        },
        save: 'Save',
        discard: 'Discard',
        confirmModal: {
            title: 'Update group?',
            message:
                'This group is used in assignments. Member changes apply to future assignments only. Existing assignments are not affected. Group name updates are applied immediately.',
            save: 'Save',
            discard: 'Discard',
        },
        success: {
            updated: 'Group updated successfully',
        },
        errors: {
            nameRequired: 'Group name is required.',
            updateFailed: 'Failed to update group. Try again.',
        },
    },
    createUser: {
        title: 'Create User',
        subtitle: 'Multiple Users',
        upload: {
            dropzone: 'Drag & drop your CSV file here, or click to browse',
            selected: 'Selected file:',
            template: 'Download CSV template',
            validate: 'Validate file',
            fileTypes: 'CSV files only (.csv)',
            maxRows: 'Maximum 1000 rows per upload',
        },
        validation: {
            title: 'Validation Results',
            validRow: 'Valid',
            summary: {
                total: 'Total rows',
                valid: 'Valid rows',
                invalid: 'Invalid rows',
            },
            uploadButton: 'Upload users',
            discardButton: 'Discard',
            skipNote: 'Only valid rows will be created. Invalid rows will be skipped.',
        },
        results: {
            title: 'Import Results',
            created: '{{count}} users created successfully',
            failed: '{{count}} rows failed',
            done: 'Done',
            resetSent: 'Password reset emails will be sent to all created users.',
        },
        errors: {
            validationFailed: 'Validation failed. Please try again.',
            importFailed: 'Import failed. Please try again.',
        },
        columns: {
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            employeeId: 'Employee ID',
            language: 'Language',
            status: 'Status',
            groups: 'Groups',
            errors: 'Errors',
        },
        processing: 'Processing users, please wait...',
        singleUser: {
            tabLabel: 'Single User',
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            employeeId: 'Employee ID',
            password: 'Temporary Password',
            language: 'Language',
            status: 'Status',
            active: 'Active',
            inactive: 'Inactive',
            english: 'English',
            russian: 'Russian',
            lithuanian: 'Lithuanian',
            userGroups: 'User Groups',
            groupsDisclaimer:
                'Group membership defines participation in future assignments. Existing assignments are not affected.',
            create: 'Create',
            discard: 'Discard',
            createSuccess: 'User created successfully',
            errors: {
                emailRequired: 'Email is required',
                emailInvalid: 'Please enter a valid email address',
                emailAlreadyExists: 'A user with this email already exists',
                firstNameRequired: 'First name is required',
                lastNameRequired: 'Last name is required',
                passwordRequired: 'Password is required',
                requiredFields: 'Please fill in all required fields',
                createFailed: 'Failed to create user. Try again.',
            },
        },
        bulkUser: {
            tabLabel: 'Multiple Users',
        },
    },
    kpis: {
        measures: {
            km: 'km',
            l100: 'l/100',
            percent: '%',
        },
        eco: {
            ecoScore: {
                name: 'ECO Score',
                tooltip: 'Total score for driving session',
            },
            fuelConsuption: {
                name: 'Fuel Consumption',
                tooltip: 'Fuel used during drive',
            },
            overspeed: {
                name: 'Speeding',
                tooltip: 'Percentage of distance driven while exceeding the speed limit',
            },
            harshAcceleration: {
                name: 'Harsh Acceleration',
                tooltip: 'Percentage of distance during which harsh acceleration occurred.',
            },
            coasting: {
                name: 'Coasting',
                tooltip: 'Percentage of possible coasting distance driven while coasting',
            },
            notOptimalRpm: {
                name: 'RPM',
                tooltip: 'Percentage of distance driven while accelerating above engine’s optimal (green) RPM range.',
            },
            cruiseControl: {
                name: 'Cruise Control',
                tooltip:
                    'Indicates how much of the distance where cruise control could be used was actually driven with cruise control engaged',
            },
            ccEfficiency: {
                name: 'Cruise Control Efficiency',
                tooltip: 'Score is calculated based on penalty points received for incorrect use of cruise control',
            },
            brakingCountVsStops: {
                name: 'Braking vs Stops',
                tooltip: 'Score is calculated based on times when brake pedal was used vs complete stops',
            },
            harshBraking: {
                name: 'Harsh Braking',
                tooltip: 'Score is calculated based on penalty points received for harsh braking with brake pedal',
            },
            speeding: {
                name: 'Speeding',
                tooltip: 'Percentage of distance driven while exceeding the speed limit',
            },
        },
    },
    lessonType: {
        '3D': 'Simulator',
        '360': 'VR Headset',
        PDF: 'PDF',
        Survey: 'Survey',
        Text: 'Text',
    },
    datepicker: {
        placeholder: 'MM/DD/YYYY',
        openButton: 'Open date picker',
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        clear: 'Clear',
        ok: 'OK',
        weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
    },
};
